import { Component, OnInit,ViewChild } from '@angular/core';
import { PdfMakeWrapper, Img } from 'pdfmake-wrapper';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { Txt, Columns, Table, Ul, Ol } from 'pdfmake-wrapper';
import { AuthService } from 'src/app/services/auth.service';
import { ThrowStmt } from '@angular/compiler';
import { map } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ActivatedRoute,Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import * as Excel from 'exceljs/dist/exceljs.min.js'
import * as fs from 'file-saver';



@Component({
  selector: 'app-fmtht',
  templateUrl: './fmtht.component.html',
  styleUrls: ['./fmtht.component.scss']
})
export class FmthtComponent implements OnInit {

  constructor(public authService: AuthService,public router: Router) { }
  id_ht;
  ngOnInit() {
    var t= localStorage.getItem("t_ht");
    this.id_ht=Number(localStorage.getItem("id_ht"));
    //console.log(t);
    switch (t) {      
      case 'P':        
        this.Pgg4();
        break;
      case 'X':
        this.generateExcel();
          break;    
      default:
        break;
    }
  }
  ht_det;
  async Pgg4(){
    const pdf = new PdfMakeWrapper(); 
    pdf.pageOrientation("landscape");  
    pdf.pageSize("letter")
    var cliente_name="";
    var codigo="";
    var usuario_nombre="";
    var nombre="";
    var fecha="";
    var tot="";

    let postData_c = {
      id:localStorage.getItem("id_cliente")
    } 
    await this.authService.service("/api/get_cliente_by_id",postData_c)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.cliente=data;
          cliente_name=this.cliente[0].razonsocial ;
                    
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
           // swal.fire('¡API incorrecta! exp', '', 'error');
  });
    
  let  postData1 = {
    id:this.id_ht
  } 
  
  await this.authService.service("/api/get_ht_id",postData1)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);
         tot=res.length;
        
        codigo=res[0].codigo;
        nombre=res[0].nombre;
        fecha=res[0].fecha;
        usuario_nombre=res[0].usuario_nombre;   
  });
  //*/
  
    pdf.add(new Table([             
        [{text:"Cliente: "+cliente_name,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
        {text:"Hoja de Trabajo Estandarizado",alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
        {text:"Código:"+codigo,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
      ], 
       ]).widths([220,230,220]).fontSize(10).bold().alignment('left').end);
       
    pdf.add(new Table([             
        [{text:"Realizado por: "+usuario_nombre+" "+fecha,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
        {text:"Nombre de la Actividad:"+nombre,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
        {text:"Revisión:"+tot,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
      ], 
       ]).widths([220,230,220]).fontSize(10).bold().alignment('left').end);
//,"Secuencia mandatoria","Chequeo de calidad","(Que)","Como","Por Que","Tiempo","Imagenes"       
var wdth1=[10,135,135,135, 24,203];
var wdth2=[10,40,40,40,40,70,70,70, 24,203];
var wdt=[]
var h1=[{text:"No.",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
{text:"(Que)",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
{text:"(Como)",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
{text:"(Por Que)",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
{text:"Tiempo",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
{text:"Imagenes",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
]
var h2=[{text:"No.",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
{text:"Seguridad del operador",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
{text:"Operacion crítica",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
{text:"Secuencia mandatoria",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
{text:"Chequeo de calidad",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
{text:"(Que)",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
{text:"(Como)",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
{text:"(Por Que)",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
{text:"Tiempo",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
{text:"Imagenes",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
]
var bndcompleto=true;
//console.log("htdet")
//console.log(localStorage.getItem("tpdf_ht"))

if(localStorage.getItem("tpdf_ht")=="1"){bndcompleto=true
}else{bndcompleto=false}
var head=[]
if(bndcompleto){ 
  wdt= wdth1;
  head=h1;
}
else{
  wdt= wdth2;
  head=h2;
}
    pdf.add(new Table([ head]).widths(wdt).fontSize(7).bold().alignment('left').end);

     let  postData = {
        id:this.id_ht
      } 
      await this.authService.service("/api/get_ht_det",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);     
            this.ht_det=data;
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              //swal.fire('¡API incorrecta! exp', '', 'error');
          });
          
          
          //{image: this.img_g5,  width: 91,height:102  ,alignment:'center'  }
         // console.log(this.ht_det);
          for(var i=0 ;i<this.ht_det.length;i++){
            var im1=Array();
            var im2=Array();
            var im3=Array();
            var im4=Array();
            
            if(this.ht_det[i].img1!=null){            
              await this.authService.service("/api/img_g4",{img:this.ht_det[i].img1})
                        .then(
                          data => {
                            var dat = JSON.stringify(data);
                            var res = JSON.parse(dat);                              
                            im1=[{image: "data:image/jpeg;base64,"+res.img,  width: 91,height:102  ,alignment:'center'  }]
                        },
                        error => {
                            var de= JSON.stringify(error);
                            var di = JSON.parse(de)    
                        });
                }
                if(this.ht_det[i].img2!=null){
                await this.authService.service("/api/img_g4",{img:this.ht_det[i].img2})
                          .then(
                            data => {
                              var dat = JSON.stringify(data);
                              var res = JSON.parse(dat);  
                              im2=[{image: "data:image/jpeg;base64,"+res.img,  width: 91,height:102  ,alignment:'center'  }];
                          },
                          error => {
                              var de= JSON.stringify(error);
                              var di = JSON.parse(de)    
                          });
                  }
                  if(this.ht_det[i].img3!=null){
                  await this.authService.service("/api/img_g4",{img:this.ht_det[i].img3})
                            .then(
                              data => {
                                var dat = JSON.stringify(data);
                                var res = JSON.parse(dat);  
                                im3=[{image: "data:image/jpeg;base64,"+res.img,  width: 91,height:102  ,alignment:'center'  }]
                            },
                            error => {
                                var de= JSON.stringify(error);
                                var di = JSON.parse(de)    
                            });
                  }
                  if(this.ht_det[i].img4!=null){
                    await this.authService.service("/api/img_g4",{img:this.ht_det[i].img4})
                              .then(
                                data => {
                                  var dat = JSON.stringify(data);
                                  var res = JSON.parse(dat);  
                                  im4=[{image: "data:image/jpeg;base64,"+res.img,  width: 91,height:102  ,alignment:'center'  }]
                              },
                              error => {
                                  var de= JSON.stringify(error);
                                  var di = JSON.parse(de)    
                              });
                    }
            //console.log(im);
            if(im1.length==0){im1.push([{text:""}]);}
            if(im2.length==0){im2.push([{text:""}]);}
            if(im3.length==0){im3.push([{text:""}]);}
            if(im4.length==0){im4.push([{text:""}]);}
            var c1=[[{text:i+1,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
            {text:this.ht_det[i].principal,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
            {text:this.ht_det[i].importante,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
            {text:this.ht_det[i].razon,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
            {text:this.ht_det[i].tiempo,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},                      
              new Table([
                      [im1,im2],
                      [im3,im4]
                    ]).layout("noBorders").end            
            ]]
            var c2=[[
              {text:i+1,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
              {text:this.simbolo(this.ht_det[i].simbolo1),alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
              {text:this.simbolo(this.ht_det[i].simbolo2),alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
              {text:this.simbolo(this.ht_det[i].simbolo3),alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
              {text:this.simbolo(this.ht_det[i].simbolo4),alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
              {text:this.ht_det[i].principal,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
              {text:this.ht_det[i].importante,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
              {text:this.ht_det[i].razon,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
              {text:this.ht_det[i].tiempo,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},                            
              new Table([[im1,im2],[im3,im4]]).layout("noBorders").end              
            ]]
            var c3=[]
            if(bndcompleto){c3=c1;}
            else{c3=c2;}
            pdf.add(new Table(c3).widths(wdt).fontSize(7).bold().alignment('left').end);            
        
           }
          //console.log("hoja de trabajo");            
    pdf.create().download(nombre+'.pdf');  
    setTimeout(function(){
      window.close();
    },4000);//

  }

  img_g1;
  img_g2;
  img_g3;
  img_g4;
  img_g5;
  msg_ht;
  ht_list;
  img(i){
    //.log(i)
     if(i===null){
       return ""
     }
     return i;
   }
   simbolo(s){
     if(s==1)return "Si";
     else return "";
   }
   cliente;
   
  async generateExcel(){

    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('HK');
    //Add Row and formatting
    var cliente_name="";
    let postData_c = {
      id:localStorage.getItem("id_cliente")
    } 
    await this.authService.service("/api/get_cliente_by_id",postData_c)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            this.cliente=data;
            cliente_name=this.cliente[0].razonsocial ;
                      
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
             // swal.fire('¡API incorrecta! exp', '', 'error');
    });  
    
    let postData = {
      id:this.id_ht
    } 
    var tot=1;
    var codigo=""
    var nombre="";
    var usuario_nombre="";
    var nombre="";
    var fecha="";
    //console.log(postData);
    await this.authService.service("/api/get_ht_id",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
           tot=res.length;
          //console.log(res);
          codigo=res[0].codigo;
          nombre=res[0].nombre;
          fecha=res[0].fecha;
          usuario_nombre=res[0].usuario_nombre;
    });
worksheet.addRow(["",
    "Cliente: "+cliente_name,"","",
    "Hoja de Trabajo Estandarizado","","",
    "Código: "+codigo,"", ""]);
worksheet.mergeCells(`B1:D1`);
worksheet.mergeCells(`E1:G1`);
worksheet.mergeCells(`H1:J1`);
worksheet.mergeCells(`K1:M1`);        
worksheet.addRow(["","Realizado por: "+usuario_nombre+" "+fecha,"","",
                    "Nombre de la Actividad: "+nombre,"","",
                    "Revisión: "+tot ,"",""]);

worksheet.mergeCells(`B2:D2`);
worksheet.mergeCells(`E2:G2`);
worksheet.mergeCells(`H2:J2`);
worksheet.mergeCells(`K2:M2`);                    
var c=worksheet.addRow([""]);
c.fill = {
  type: 'pattern',
  pattern: 'solid',
  fgColor: { argb: 'FFCCFFE5' }
};
let postData3={ img:"im1.png" }
await this.authService.service("/api/img_g4",postData3)
.then(
  data => {
    var dat = JSON.stringify(data);
    var res = JSON.parse(dat);  

    this.img_g1="data:image/jpeg;base64,"+res.img;
    const imageId1 = workbook.addImage({base64: this.img_g1, extension: 'png',});
    worksheet.addImage(imageId1, { tl: { col: 1,  row: 2}, ext: { width: 20,height: 20 }});
},
error => {
    var de= JSON.stringify(error);
    var di = JSON.parse(de)        
});
postData3={img:"im2.png"}
await this.authService.service("/api/img_g4",postData3)
.then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);  
      const imageId1 = workbook.addImage({base64: "data:image/jpeg;base64,"+res.img, extension: 'png',});
      worksheet.addImage(imageId1, { tl: { col: 2,  row: 2}, ext: { width: 20,height: 20 }});
  },
  error => {
      var de= JSON.stringify(error);
      var di = JSON.parse(de)      
 });
postData3={img:"im3.png"}
await this.authService.service("/api/img_g4",postData3)
.then(
  data => {
    var dat = JSON.stringify(data);
    var res = JSON.parse(dat);  

    const imageId1 = workbook.addImage({base64: "data:image/jpeg;base64,"+res.img, extension: 'png',});
    worksheet.addImage(imageId1, { tl: { col: 3,  row: 2}, ext: { width: 20,height: 20 }});
},
error => {
    var de= JSON.stringify(error);
    var di = JSON.parse(de)    
});
postData3={img:"im4.png"}
await this.authService.service("/api/img_g4",postData3)
.then(
data => {
  var dat = JSON.stringify(data);
  var res = JSON.parse(dat);  
  const imageId1 = workbook.addImage({base64: "data:image/jpeg;base64,"+res.img, extension: 'png',});
  worksheet.addImage(imageId1, { tl: { col: 4,  row: 2}, ext: { width: 20,height: 20 }});
  this.img_g4="data:image/jpeg;base64,"+res.img;
},
error => {
  var de= JSON.stringify(error);
  var di = JSON.parse(de)  
});
var c=worksheet.addRow(["No.","Seguridad del operador","Operacion crítica","Secuencia mandatoria","Chequeo de calidad","(Que)","Como","Por Que","Tiempo","Imagenes"]);
c.fill = {
  type: 'pattern',
  pattern: 'solid',
  fgColor: { argb: 'FFCCFFE5' }
};
postData = {
  id:this.id_ht
} 
await this.authService.service("/api/get_ht_det",postData)
.then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);     
      this.ht_det=data;
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        //swal.fire('¡API incorrecta! exp', '', 'error');
    });

    for(var i=0 ;i<this.ht_det.length;i++){
            //if(this.ht_det[i].img1===null){}else
 
      
     var rg= worksheet.addRow([i+1,
              this.simbolo(this.ht_det[i].simbolo1),
              this.simbolo(this.ht_det[i].simbolo2),
              this.simbolo(this.ht_det[i].simbolo3),
              this.simbolo(this.ht_det[i].simbolo4),this.ht_det[i].principal,this.ht_det[i].importante,this.ht_det[i].razon,this.ht_det[i].tiempo,
              "",
              "",
              "",
              ""]);
    //console.log("hoja de trabajo");          
    //console.log(this.ht_det);
    if(this.ht_det[i].img1!=null){
    await this.authService.service("/api/img_g4",{img:this.ht_det[i].img1})
              .then(
                data => {
                  var dat = JSON.stringify(data);
                  var res = JSON.parse(dat);  
                  const imageId1 = workbook.addImage({base64: "data:image/jpeg;base64,"+res.img, extension: 'png',});
                  worksheet.addImage(imageId1, { tl: { col: 9,  row: 4+i}, ext: { width: 150,height: 150 }});
              },
              error => {
                  var de= JSON.stringify(error);
                  var di = JSON.parse(de)    
              });
      }
      if(this.ht_det[i].img2!=null){
      await this.authService.service("/api/img_g4",{img:this.ht_det[i].img2})
                .then(
                  data => {
                    var dat = JSON.stringify(data);
                    var res = JSON.parse(dat);  
                    const imageId1 = workbook.addImage({base64: "data:image/jpeg;base64,"+res.img, extension: 'png',});
                    worksheet.addImage(imageId1, { tl: { col: 10,  row: 4+i}, ext: { width: 150,height: 150 }});
                },
                error => {
                    var de= JSON.stringify(error);
                    var di = JSON.parse(de)    
                });
        }
        if(this.ht_det[i].img3!=null){
        await this.authService.service("/api/img_g4",{img:this.ht_det[i].img3})
                  .then(
                    data => {
                      var dat = JSON.stringify(data);
                      var res = JSON.parse(dat);  
                      const imageId1 = workbook.addImage({base64: "data:image/jpeg;base64,"+res.img, extension: 'png',});
                      worksheet.addImage(imageId1, { tl: { col: 11,  row: 4+i}, ext: { width: 150,height: 150 }});
                  },
                  error => {
                      var de= JSON.stringify(error);
                      var di = JSON.parse(de)    
                  });
        }
        if(this.ht_det[i].img4!=null){
          await this.authService.service("/api/img_g4",{img:this.ht_det[i].img4})
                    .then(
                      data => {
                        var dat = JSON.stringify(data);
                        var res = JSON.parse(dat);  
                        const imageId1 = workbook.addImage({base64: "data:image/jpeg;base64,"+res.img, extension: 'png',});
                        worksheet.addImage(imageId1, { tl: { col: 12,  row: 4+i}, ext: { width: 150,height: 150 }});
                    },
                    error => {
                        var de= JSON.stringify(error);
                        var di = JSON.parse(de)    
                    });
          }
          rg.height = 115;
  }
  
  
  worksheet.getColumn(1).alignment={vertical: 'middle',horizontal:"left" ,wrapText: true} 
  worksheet.getColumn(2).alignment={vertical: 'middle',horizontal:"left" ,wrapText: true} 
  worksheet.getColumn(3).alignment={vertical: 'middle',horizontal:"left" ,wrapText: true} 
  worksheet.getColumn(4).alignment={vertical: 'middle',horizontal:"left" ,wrapText: true} 
  worksheet.getColumn(5).alignment={vertical: 'middle',horizontal:"left" ,wrapText: true} 
  worksheet.getColumn(6).alignment={vertical: 'middle',horizontal:"left" ,wrapText: true} 
  worksheet.getColumn(7).alignment={vertical: 'middle',horizontal:"left" ,wrapText: true} 
  worksheet.getColumn(8).alignment={vertical: 'middle',horizontal:"left" ,wrapText: true} 
  worksheet.getColumn(9).alignment={vertical: 'middle',horizontal:"left" ,wrapText: true} 
  worksheet.getColumn(10).alignment={vertical: 'middle',horizontal:"left" ,wrapText: true}   
  worksheet.getColumn(1).width=5;
  worksheet.getColumn(2).width=10;
  worksheet.getColumn(3).width=10;
  worksheet.getColumn(4).width=10;
  worksheet.getColumn(5).width=10;
  worksheet.getColumn(6).width=20;
  worksheet.getColumn(7).width=20;
  worksheet.getColumn(8).width=20;
  worksheet.getColumn(9).width=5;
  worksheet.getColumn(10).width=20;  

  worksheet.getColumn(10).width = 22;   
worksheet.getColumn(11).width = 22;   
worksheet.getColumn(12).width = 22;   
worksheet.getColumn(13).width = 22;   
    let footerRow = worksheet.addRow(['Report V1.']);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    //Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);
    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'CarData.xlsx');
    });  
    setTimeout(function(){
      window.close();
    },4000);


  }
}
